import React from 'react';

const HideWarnings = React.createContext();

export default HideWarnings;
